var angular = require('angular');

function sortable() {

  var template = function(element) {
    return '<TAG ng-click="sortBy()" ng-class="sortClass()"><ng-transclude /><span class="icon" /></TAG>'
      .replace(/TAG/g, element.prop('tagName'));
  };

  var controller = function($scope, $element, $attrs) {
    var key = $element.parent().attr('sortable-key');
    var orderBy = $scope.$parent.orderBy = $scope.$parent.orderBy || {};

    if (key) {
      orderBy = $scope.$parent.orderBy[key] = $scope.$parent.orderBy[key] || {};
    }

    $scope.setOrderBy = function() {
      orderBy.propertyName = $scope.propertyName;
      orderBy.reverse = angular.isDefined($attrs.reverse);

      if (angular.isDefined($attrs.function)) {
        orderBy.property = function(object) {
          return object[$scope.propertyName]();
        };
      } else {
        orderBy.property = $scope.propertyName.split(' ');
      }
    };

    $scope.sortBy = function() {
      if (orderBy.propertyName === $scope.propertyName) {
        orderBy.reverse = ! orderBy.reverse;
      } else {
        $scope.setOrderBy();
      }
    };

    $scope.sortClass = function() {
      if (orderBy.propertyName === $scope.propertyName) {
        return {
          sortable: true,
          active: true,
          reverse: orderBy.reverse
        };
      } else {
        return 'sortable';
      }
    };

  };

  controller.$inject = ['$scope', '$element', '$attrs'];

  var link = function(scope, element, attrs) {
    if (angular.isDefined(scope.ngShow) && ! scope.ngShow) {
      return;
    }

    if (angular.isDefined(attrs.default)) {
      scope.setOrderBy();
    }
  };

  return {
    restrict: 'A',
    replace: true,
    transclude: true,
    scope: {
      propertyName: '@sortable',
      ngShow: '='
    },
    template: template,
    controller: controller,
    link: link
  };

}

module.exports = sortable;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/directives/sortable.js
 ** module id = 156
 ** module chunks = 1
 **/